import React from "react";

interface QuickWinsIconProps {
  className?: string;
  onClick?: () => void;
}

export const QuickWinsIcon = ({ className, onClick }: QuickWinsIconProps) => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M18.25 3H22.7812C23.0938 3 23.25 3.15625 23.25 3.46875V5.89062C23.25 7.14062 22.638 8.35156 21.4141 9.52344C20.2161 10.6953 18.7318 11.4115 16.9609 11.6719C16.4401 12.7917 15.7891 13.6641 15.0078 14.2891C14.2266 14.9141 13.4323 15.3047 12.625 15.4609V19.25H15.9844C16.2708 19.25 16.5052 19.3411 16.6875 19.5234C16.8958 19.7318 17 19.9792 17 20.2656C17 20.4219 16.9219 20.5 16.7656 20.5H7.23438C7.07812 20.5 7 20.4219 7 20.2656C7 19.9792 7.09115 19.7318 7.27344 19.5234C7.48177 19.3411 7.72917 19.25 8.01562 19.25H11.375V15.4609C10.8542 15.3568 10.3464 15.1615 9.85156 14.875C9.35677 14.5885 8.84896 14.1719 8.32812 13.625C7.83333 13.0781 7.40365 12.4271 7.03906 11.6719C5.26823 11.4115 3.77083 10.6953 2.54688 9.52344C1.34896 8.35156 0.75 7.14062 0.75 5.89062V3.46875C0.75 3.15625 0.90625 3 1.21875 3H5.75V0.96875C5.75 0.65625 5.90625 0.5 6.21875 0.5H17.7812C18.0938 0.5 18.25 0.65625 18.25 0.96875V3ZM2 5.89062C2 6.72396 2.41667 7.58333 3.25 8.46875C4.10938 9.32812 5.17708 9.92708 6.45312 10.2656C5.98438 8.78125 5.75 7.08854 5.75 5.1875V4.25H2V5.89062ZM8.44531 11.5938C9.40885 13.3646 10.5938 14.25 12 14.25C13.4062 14.25 14.5911 13.3646 15.5547 11.5938C16.5182 9.82292 17 7.6875 17 5.1875V1.75H7V5.1875C7 7.6875 7.48177 9.82292 8.44531 11.5938ZM22 5.89062V4.25H18.25V5.1875C18.25 7.08854 18.0156 8.78125 17.5469 10.2656C18.8229 9.92708 19.8776 9.32812 20.7109 8.46875C21.5703 7.58333 22 6.72396 22 5.89062Z"
      fill="#0344DC"
    />
  </svg>
);

QuickWinsIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
